const About = ({ content }) => {
	return (
		<div className="about-text-section">
			<div className="text-white px-1" dangerouslySetInnerHTML={{ __html: content?.about || '' }} />
		</div>
	);
};

export default About;
